export { default } from './InterstitialLink'
